module.exports = __webpack_public_path__ + "media/images/t-drsquatch-square-de52eb6fdb9ec379fd4d5eb187560f38.png";